import { ECommerceActionType } from "./actions";

// just to have type-check in redux-saga take(...)
export function actionTypes(...actionTypesArray: ECommerceActionType[]): ECommerceActionType[] { return actionTypesArray }
